import script from "./update-beneficiary-check.vue?vue&type=script&setup=true&lang=js"
export * from "./update-beneficiary-check.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__